import React from 'react';
import classNameBind from 'classnames/bind';
import Icon from '../Icon';

import styles from './Message.module.css';

const bindClasses = classNameBind.bind(styles);

const Message = ({
  message,
  messageType,
  box,
  card,
  condensed,
  vertical,
  centerHorizontal,
  centerVertical,
  dataId,
  additionalMessage,
}) => (
  message
    ? (
      <div
        className={bindClasses('message', {
          box,
          card,
          condensed,
          vertical,
          centerHorizontal,
          centerVertical,
        })}
        data-ppuc-id={dataId}
      >
        {messageType !== 'subdued' && (
        <Icon
          name={messageType === 'error' ? 'exclamation-mark-circle' : 'info-circle'}
          color={messageType === 'error' ? 'red' : 'blue'}
          size={card ? 'medium' : 'default'}
        />
        )}
        <div className={bindClasses('message-text', messageType)}>
          <p data-ppuc-id={`${dataId}.message`}>
            {message}
          </p>
        </div>
        {additionalMessage && (
          <div className={bindClasses('message-additional')}>
            {additionalMessage}
          </div>
        )}
      </div>
    )
    : null
);

Message.defaultProps = {
  message: '',
  messageType: 'error',
  box: false,
  card: false,
  condensed: false,
  vertical: true,
  centerHorizontal: false,
  centerVertical: false,
  dataId: 'Message',
  additionalMessage: null,
};

export default Message;
